import React from 'react'
import { useNavigate } from 'react-router-dom'
import type { Track } from 'types/track'
import { DropdownMenu } from 'components/ds'

type Props = {
  manageTrackFormats: boolean
  disabled: boolean
  closeMenu: () => void
  track: Track
}

const ManageFilesAndFormats = ({
  manageTrackFormats,
  disabled,
  track,
}: Props): React.ReactNode => {
  const navigate = useNavigate()
  if (!manageTrackFormats || !track?.permissions?.manage) return null
  return (
    <DropdownMenu.Item
      disabled={disabled}
      onSelect={() => navigate(`/explorer/tracks/${track.id}/formats`)}
    >
      Files and format
    </DropdownMenu.Item>
  )
}

export default ManageFilesAndFormats
